module.exports = __webpack_public_path__ + "61717677e6593b14744336ac0a1ceac7.png";